import { CloseButtonProps } from 'react-toastify'

import { Icon } from '@/shared/ui'

export const CloseButton = ({ closeToast }: CloseButtonProps) => {
  return (
    <button
      onClick={closeToast}
      className="absolute top-2 right-2 cursor-pointer"
    >
      <Icon name="close" size={16} />
      <span className="sr-only">토스트 닫기</span>
    </button>
  )
}
